import React from 'react';
import Modal from "@mui/material/Modal";
import Button from '@mui/material/Button';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const ModalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "500px",
    height: "200px",
    borderRadius: "10px",
    backgroundColor: "white",
    zIndex: '9999999999999'
};

function Failure({
    isModalOpen,
    setIsModalOpen,
    modalMessage,
    refreshDataAction
}) {
    const handelClick = () => {
        setIsModalOpen(false);
        refreshDataAction();
    };
  return (
    <Modal
        open={isModalOpen}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
    >
        <div style={ModalStyle}>
            <div className='modalContainer'>
                <div className='topBorderError'></div>
                <div className='icon'>
                    <div className='iconFail'>
                        <CancelOutlinedIcon sx={{width: '2.54em', height: '2em', color: 'red' }}/>
                    </div>
                </div>
                <div className='message'>
                    <span >{
                        modalMessage && (typeof modalMessage === "string") ?
                            modalMessage
                            : "Request Failed"
                    }</span>
                </div>
                <div className='actionButton'>
                {
                    <Button variant="contained" color="error" onClick={handelClick}>
                        OK
                    </Button>
                }
                </div>
                </div>
            </div>
    </Modal>
  );
}

export default Failure;